import { Pipe, PipeTransform } from '@angular/core';
import { AppConfig } from '../app.config';

@Pipe({
  name: 'statusNames',
})
export class StatusNamesPipe implements PipeTransform {
  constructor(private appConfig: AppConfig) {}

  transform(value: any, args?: any): any {
    let statuses = this.appConfig.getFullStatusList();
    let indexes = statuses.map((item) => {
      return item.key;
    });
    return statuses[indexes.indexOf(value)]?.label;
  }
}
